// extracted by mini-css-extract-plugin
module.exports = {"switch":"ExplicitFilter_switch__1BQyU"};